import * as React from 'react'
import { FloatingContainerTitle } from '../casting-styled.component'
import ButtonGroupComponent from '../../../shared/button-group.component'
import { StoreProps } from '../../../../services/stores/casting.store'
import { castingWeeksInterval } from '../../../../services/models/castings.service'
import { I18nService } from '../../../../services/utils/i18n.service'

const i18nScoped = new I18nService(require('./casting-frequency-week-interval-picker.component.yml'))

export default function CastingFrequencyWeekIntervalPickerComponent ({ data: { slots, offeredService }, store }: StoreProps) {
  const weeksInterval = slots.length && slots[0].weeks_interval

  const setWeeksInterval = React.useCallback((weeksInterval: number) =>  {
    store.setSlots(slots.map(slot => ({ ...slot, weeks_interval: weeksInterval })))
    if (offeredService.rentable_unit_of_work === 'day') store.nextFocus({ closeOnMobile: true })
  }, [offeredService.rentable_unit_of_work, slots, store])

  return <>
    <FloatingContainerTitle>{ i18nScoped.t('frequency') }</FloatingContainerTitle>

    <ButtonGroupComponent
      name="tooltipFrequencyOption"
      data={ [1, 2, 3, 4].map(value => ({ text: castingWeeksInterval(value), value })) }
      value={ weeksInterval }
      onChange={ setWeeksInterval } />
  </>
}
